import React                      from 'react'
import { Button }                 from 'antd'

import { ModalConfirm }           from './06_ui_modal_prompt'


interface IEditButtons<T>
{ onEdit: ( row:T )=> any
, onDelete: ( row: T ) => any
, show?: string
, row: T
, disabled?: boolean
  // TODO MACHINES: this is only used for the Machines screen
, hideEdit?: boolean
, hideDelete?: boolean
} ;


export const EditButtons: React.FC< IEditButtons<any> > = ( props ) =>
{
  const style = { height: '18px' } 
      , on_edit   = ( ) => props.onEdit( props.row ) 
      , on_delete = ( ) => 
          ModalConfirm( ( ) => props.onDelete( props.row ) ) ;

  return <div className={ "float-right text-nowrap " + (props.show || 'show-display') }>
           {
             props.hideEdit?
             null
           :
             <Button
               style={ style }
               disabled={ props.disabled }
               onClick={ on_edit }
               icon="edit"
               type="ghost"
               className="ba-0" />
           }
           {
             props.hideDelete?
               null
             : 
               <Button
                 style={ style }
                 disabled={ props.disabled }
                 onClick={ on_delete }
                 icon="delete"
                 type="ghost"
                 className="ba-0" />
           }
         </div>
}